import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKCARTFUNNELHEADERBLOCK_LEGACY_FIELD_ORDER = [
  "logo",
  { type: 'separator' },
  "background_color",
  "background_image"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskCartFunnelHeaderBlockDescriptor: _generatedKioskCartFunnelHeaderBlockDescriptor,
  kioskCartFunnelHeaderBlockBlocDefinition,
  kioskCartFunnelHeaderBlockDashboardLayout,
  kioskCartFunnelHeaderBlockConfig,
  kioskCartFunnelHeaderBlockResolveConfig,
  kioskCartFunnelHeaderBlockProperties,
} = doodBlockConfig(
  {
    name: "Kiosk Cart funnel / Header",
    componentType: 'KioskCartFunnelHeaderBlockComponent',
    category: 'kiosk',
    description: "Kiosk Cart funnel / Header.",
    keywords: [],
    allowedIn: [
      { bloc: 'KioskCartFunnelPageComponent', slot: 'header' },
    ],


    sharedFields: {}
  },

  () => ({
    logo: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-funnel-header.logo.label",
        help: "pages.blocks.kiosk-cart-funnel-header.logo.help",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-900"},
      options: {
        label: "pages.blocks.kiosk-cart-funnel-header.text-color.label",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.kiosk-cart-funnel-header.background-color.label",
      }
    }),
    background_image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-funnel-header.background-image.label",
        help: "pages.blocks.kiosk-cart-funnel-header.background-image.help",
      }
    })
  }),

  () => ({
    omitFields: ["text_color"] as const,
    tabs: [
      {
        label: "pages.blocks.kiosk-cart-funnel-header.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-cart-funnel-header.fieldset.logo.label",
            fields: ["logo"],
          },
          {
            legend: "pages.blocks.kiosk-cart-funnel-header.fieldset.background.label",
            fields: ["background_color", "background_image"],
          },
        ],
      },
    ],
  })
);

export function kioskCartFunnelHeaderBlockDescriptor(): IBlockDescriptor;
export function kioskCartFunnelHeaderBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskCartFunnelHeaderBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskCartFunnelHeaderBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskCartFunnelHeaderBlockDescriptor, kioskCartFunnelHeaderBlockProperties, fieldOrder);
}

export {
  kioskCartFunnelHeaderBlockBlocDefinition,
  kioskCartFunnelHeaderBlockDashboardLayout,
  kioskCartFunnelHeaderBlockProperties,
  kioskCartFunnelHeaderBlockConfig,
  kioskCartFunnelHeaderBlockResolveConfig,
};

export type KioskCartFunnelHeaderBlockConfig = typeof kioskCartFunnelHeaderBlockConfig;
